import { css } from "@emotion/css";

export const monitoringDetailsTableWrapperStyle = css({
  width: "100%",
  table: {
    borderCollapse: "collapse",
    width: "100%",
  },
  "thead tr, tbody tr": {
    borderBottomWidth: 0,
    borderBottomStyle: "none",
  },
  "th, td": {
    boxSizing: "border-box",
    padding: "var(--space-2)",
    border: "1px solid var(--border-base)",
    fontWeight: "var(--font-weight-regular)",
    fontSize: "var(--font-size-75)",
    lineHeight: "var(--font-line-height-2)",
    verticalAlign: "top",
    "& *": {
      fontWeight: "var(--font-weight-regular)",
      fontSize: "var(--font-size-75)",
      lineHeight: "var(--font-line-height-2)",
    },
  },
  "tr:first-child th": {
    borderTop: "none",
  },
  "tr th:first-child, tr td:first-child": {
    borderLeft: "none",
  },
  "tr th:last-child, tr td:last-child": {
    borderRight: "none",
  },
  "tbody tr:last-child td": {
    borderBottom: "none",
  },
});
